import { render, staticRenderFns } from "./EbAdminTabMenuPost.vue?vue&type=template&id=0117be55"
import script from "./EbAdminTabMenuPost.vue?vue&type=script&lang=js"
export * from "./EbAdminTabMenuPost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports